'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _ProgramType = require('./ProgramType');

var _ProgramType2 = _interopRequireDefault(_ProgramType);

var _selectors = require('./selectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'program-types';

var getActive = function getActive() {
  var types = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var type = arguments[1];

  return types.indexOf(('' + type).toLowerCase()) !== -1;
};

function ProgramTypes(_ref) {
  var programTypes = _ref.programTypes,
      educationLevels = _ref.educationLevels;

  return _react2.default.createElement(
    'div',
    { className: CLASS_NAME },
    (0, _keys2.default)(educationLevels).map(function (key) {
      var educationLevel = educationLevels[key];
      var alt = educationLevel.alt,
          id = educationLevel.id;


      return _react2.default.createElement(_ProgramType2.default, {
        key: key,
        label: alt,
        id: id,
        active: getActive(programTypes, id)
      });
    })
  );
}

exports.default = (0, _reactRedux.connect)(_selectors.mapStateToProps)(ProgramTypes);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/ProgramTypes/ProgramTypes.jsx
// module id = 1114
// module chunks = 0